import {
    IFetchForgotPasswordAction,
    IFetchChangePasswordAction,
    ISetLoginAction,
    IFetchResetPasswordAction,
    ISetResetPasswordEmailSentAction,
    LoginPayload,
    IFetchGoogleLoginAction,
    ISetGoogleLoginErrorMessageAction,
} from './interface';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
interface ILoginSlice {
    isLoggedIn: boolean;
    isResetPasswordEmailSent: boolean;
    googleLoginErrorMessage: string;
    uiState: {
        isLoginLoading: boolean;
        isForgotPasswordLoading: boolean;
        isChangePasswordLoading: boolean;
        isResetPasswordLoading: boolean;
        isFetchInitialDataLoading: boolean;
        isGoogleLoginLoading: boolean;
    };
}

const initialState: ILoginSlice = {
    isLoggedIn: false,
    isResetPasswordEmailSent: false,
    googleLoginErrorMessage: '',
    uiState: {
        isLoginLoading: false,
        isForgotPasswordLoading: false,
        isChangePasswordLoading: false,
        isResetPasswordLoading: false,
        isFetchInitialDataLoading: false,
        isGoogleLoginLoading: false,
    },
};

export const sliceName = 'login';
export const loginSlice = createSlice({
    name: sliceName,
    initialState,
    reducers: {
        fetchLogin: (state, _action: PayloadAction<LoginPayload>) => {
            state.uiState.isLoginLoading = true;
        },
        setLogin: (state, action: PayloadAction<ISetLoginAction>) => {
            state.isLoggedIn = action.payload.isLoggedIn;
            state.uiState.isLoginLoading = false;
        },
        setResetPasswordEmailSent: (
            state,
            action: PayloadAction<ISetResetPasswordEmailSentAction>
        ) => {
            state.isResetPasswordEmailSent =
                action.payload.resetPasswordEmailSent;
        },
        setLoginFailed: (state) => {
            state.uiState.isLoginLoading = false;
        },
        fetchForgotPassword: (
            state,
            _action: PayloadAction<IFetchForgotPasswordAction>
        ) => {
            state.uiState.isForgotPasswordLoading = true;
        },
        setForgotPasswordDone: (state) => {
            state.uiState.isForgotPasswordLoading = false;
        },
        fetchResetPassword: (
            state,
            _action: PayloadAction<IFetchResetPasswordAction>
        ) => {
            state.uiState.isResetPasswordLoading = true;
        },
        setResetPasswordDone: (state) => {
            state.uiState.isResetPasswordLoading = false;
        },
        fetchChangePassword: (
            state,
            _action: PayloadAction<IFetchChangePasswordAction>
        ) => {
            state.uiState.isChangePasswordLoading = true;
        },
        setChangePasswordDone: (state) => {
            state.uiState.isChangePasswordLoading = false;
        },
        fetchInitialData: (state) => {
            state.uiState.isFetchInitialDataLoading = true;
        },
        setFetchInitialDataDone: (state) => {
            state.uiState.isFetchInitialDataLoading = false;
        },
        fetchGoogleLogin: (
            state,
            _action: PayloadAction<IFetchGoogleLoginAction>
        ) => {
            state.uiState.isGoogleLoginLoading = true;
        },
        setGoogleLoginDone: (state) => {
            state.uiState.isGoogleLoginLoading = false;
        },
        setGoogleLoginErrorMessage: (
            state,
            action: PayloadAction<ISetGoogleLoginErrorMessageAction>
        ) => {
            state.googleLoginErrorMessage =
                action.payload.googleLoginErrorMessage;
        },
        logout: () => {},
    },
});

export const loginActions = loginSlice.actions;
export default loginSlice.reducer;
